module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs product-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n      回款总金额：" + _vm._s(_vm.totalAmount) + _vm._s(_vm.Unit) + "\n    ")]), _vm._v(" "), (_vm.moduleName !== 'approvalApi') ? _c('div', {
    staticClass: "inline-item"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._v("新建回款")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.tableClick($event)
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _vm._l((_vm.tableHead), function(head, index) {
    return _c('el-table-column', {
      key: head.attr,
      attrs: {
        "prop": head.attr,
        "label": head.attrName,
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(head.attr === 'paymentNo') ? [(!scope.row.result[index].popType) ? _c('span', [_vm._v(_vm._s(scope.row.result[index].attrValue))]) : _c('a', {
            attrs: {
              "data-type": "detail",
              "data-id": scope.row.result[index].id,
              "data-popmodel": scope.row.result[index].popModel,
              "data-red": scope.row.result[index].isRed
            }
          }, [_vm._v("\n              " + _vm._s(scope.row.result[index].attrValue) + "\n            ")])] : (head.fieldType === 5 || head.fieldType === 6) ? _vm._l((_vm.strToArr(scope.row.result[index].attrValue)), function(img) {
            return _c('img', {
              key: img,
              staticClass: "imgWidth",
              attrs: {
                "data-type": "img",
                "data-url": img,
                "src": img,
                "height": "30"
              }
            })
          }) : (head.fieldType === 8) ? [_vm._v("\n            " + _vm._s(_vm._f("files")(scope.row.result[index].attrValue)) + "\n          ")] : (scope.row.result[index]) ? [_c('span', [_vm._v(_vm._s(scope.row.result[index].attrValue || (scope.row.result[index].attrValue === 0 ? 0 : '--')))])] : _vm._e()]
        }
      }])
    })
  })], 2)], 1), _vm._v(" "), (_vm.paymentShow) ? _c('add-payment', {
    ref: "payment",
    attrs: {
      "moduleName": 'paymentApi',
      "modal": false,
      "initData": _vm.initData
    },
    on: {
      "closeDialog": _vm.paymentClose
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30fb2e9d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/contract/payment-list.vue
// module id = 1245
// module chunks = 82